import { useContext } from 'react';
import {
    TaskBeaconSnapshotContext,
    TaskBeaconSnapshotContextData
} from './context';

export function useTaskBeaconSnapshot(): TaskBeaconSnapshotContextData {
    const data = useContext<TaskBeaconSnapshotContextData | undefined>(
        TaskBeaconSnapshotContext
    );

    if (!data) {
        throw new Error(
            "TaskBeaconSnapshotProvider unavailable. Are you sure you're using this in a nested component of an TaskBeaconSnapshotProvider?"
        );
    }

    return data;
}
